import { render } from "./WhatsappSystemEdit.vue?vue&type=template&id=e1b43b46&scoped=true"
import script from "./WhatsappSystemEdit.vue?vue&type=script&lang=js"
export * from "./WhatsappSystemEdit.vue?vue&type=script&lang=js"

import "./WhatsappSystemEdit.vue?vue&type=style&index=0&id=e1b43b46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1b43b46"]])

export default __exports__